/**
 * Utility functions for the UI package
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines and merges CSS class names with Tailwind CSS conflict resolution.
 * Uses clsx for conditional classes and tailwind-merge to resolve conflicts.
 *
 * @param inputs - Variable number of class values (strings, objects, arrays)
 * @returns Merged and deduplicated class string
 *
 * @example
 * cn("text-red-500", "text-blue-500") // Returns "text-blue-500" (last one wins)
 * cn("px-4", { "py-2": true, "py-4": false }) // Returns "px-4 py-2"
 */
const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs));
};

export { cn };
